import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Header/Header.js'
import '@isceco/widget-library2/basic-elements/LanguageSwitcher/LanguageSwitcher.js'
import WebComponent from '../../WebComponent.js'
import ConfigUtil from "../../services/ConfigUtil";

export default class Header extends WebComponent {

  get translationFile() {
    return './views/Header/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()

    new ConfigUtil().retrieveConfiguration()
      .then(config => {
        this.stage = config.stage
      })
      .then(_ => {
        this.render()
      });
  }

  get css() {
    return css`
      .user-language {
        display: flex;
        align-items: end;
        flex-direction: column;
      }

      #stage-info {
        position: absolute;
        top: 1em;
        left: -2em;
        background-color: yellow;
        transform: rotate(-45deg);
        transform-origin: center;
        text-align: center;
        font-size: 1.25em;
        word-break: normal;
        width: 8em;
        padding: .4em;
      }

      #stage-info[title=EN] {
        background-color: var(--isceco-color-red-500);
      }

      #stage-info[title=IN] {
        background-color: var(--isceco-color-yellow-500);
      }

      #stage-info[title=VP] {
        background-color: var(--isceco-color-green-500);
      }
    `
  }

  getTemplate() {
    return html`
      ${this.stage && this.stage !== 'PR' ?
        html`
          <aside id="stage-info" title="${this.stage}">${this.stage}</aside>
        `
        : ''}
      <isceco-header text="${this.i18n.translate('header.text')}">
        <div class="user-language">
          <isceco-language></isceco-language>
        </div>
      </isceco-header>
    `
  }
}

customElements.define('mindestlohn-frontend-header', Header)
